import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Homepage from "./pages/homepage";
import Intro from "./pages/intro";
import styled from "styled-components";
import FirstRescueShowcase from "./pages/showcase/firstRescueShowcase";
import ScrollToTop from "./helper/scrollToTop";
import AdventurePage from "./adventure/AdventurePage";
import EditorialPage from "./editorial/EditorialPage";

/* Dark shell for the legacy pages only — the editorial page owns its
   own background. */
const DarkWrapper = styled.div`
  min-height: 100vh;
  height: auto;
  background-color: #181818;
`;

const dark = (node: React.ReactNode) => <DarkWrapper>{node}</DarkWrapper>;

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<EditorialPage />} />
        <Route path="/adventure-v1" element={dark(<AdventurePage />)} />
        <Route path="/classic" element={dark(<Homepage />)} />
        <Route path="/intro" element={dark(<Intro />)} />
        <Route path="/home" element={dark(<Homepage />)} />
        <Route
          path="/showcase/firstrescue"
          element={dark(<FirstRescueShowcase />)}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
